export default "__VITE_ASSET__5IxWnxpP__"